import React, {useEffect, useState} from 'react';
import {Drawer, Layout} from "antd";
import MenuOptions from "./MenuOptions";


const { Sider } = Layout;
type Props = {
    collapsed: boolean;
};

const MOBILE_MQ = '(max-width: 768px)';

const Sidebar: React.FC<Props> = ({collapsed}) => {
    const [collapse, setCollapse] = useState(false);
    const [isMobile, setIsMobile] = useState<boolean>(() => window.matchMedia(MOBILE_MQ).matches);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => { setCollapse(collapsed); }, [collapsed]);

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_MQ);
        const onChange = () => setIsMobile(mq.matches);
        onChange();
        mq.addListener(onChange);
        return () => mq.removeListener(onChange);
    }, []);

    // ── Mobile: a left-sliding overlay drawer instead of an inline accordion ──
    if (isMobile) {
        return (
            <>
                <button className="mobile-menu-trigger" onClick={() => setDrawerOpen(true)}>
                    <i className="pi pi-bars" />
                    <span>Menu</span>
                </button>
                <Drawer
                    placement="left"
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    width={260}
                    closable
                    bodyStyle={{padding: '8px 6px', background: '#fff'}}
                    headerStyle={{display: 'none'}}
                    className="app-nav-drawer"
                >
                    <MenuOptions collapsed={false} onNavigate={() => setDrawerOpen(false)} />
                </Drawer>
            </>
        );
    }

    // ── Desktop: sticky sidebar ──
    return (
        <Sider
            style={{
                overflow: "auto",
                // Fit inside the window (sticky top + margins), so the last
                // items (Settings) can always be scrolled into view.
                height: "calc(100vh - 40px)",
                position: "sticky",
                top: 15,
                left: 0,
                borderRadius: "15px"
            }}
            theme={"light"} trigger={null}
            width={250}
            className="my-2 mx-2 p-3"
            collapsible collapsed={collapse} onCollapse={() => setCollapse(collapse)}>
            <div>
                <MenuOptions collapsed={collapsed}/>
            </div>
        </Sider>
    );
}

export default Sidebar;
